import React, { useReducer } from 'react';
import axios from 'axios';
import moment from "moment";
import { AppContext } from './appContext';
import appReducer from './appReducer';

console.info(`process.env.NODE_ENV: ${process.env.NODE_ENV}`);
const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
console.info(`process.env.NODE_ENV === 'production': ${process.env.NODE_ENV === 'production'}`, { baseURL });

const accessToken = localStorage.getItem('accessToken');
let API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, });

/*const apiClient = () => {
    const accessToken = localStorage.getItem('accessToken');
    return axios.create({baseURL, headers: {'Authorization': `Bearer ${accessToken}`},});
}*/

export const AppState = props => {
    const initialState = {
        loading: false,
        user: {
            accessToken: '',
            email: '',
            firstName: '',
            lastName: '',
        },
        organization: {
            verified: false,
            legalEntityName: '',
            entityType: '',
            website: '',
            EIN: '',
            street: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            createdAt: '',
            updatedAt: '',
            primaryContact: {
                firstName: '',
                lastName: '',
                email: '',
                contactNumber: '',
                signatoryType: '',
                linkedInProfile: '',
                ssn: '',
                dob: '',
            },
            secondaryContact: {
                firstName: '',
                lastName: '',
                contactNumber: '',
                email: '',
                linkedInProfile: '',
            },
            peopleOpsContact: {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                email: '',
            },
            perkBudgetApproverContact: {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                email: '',
            },
            subscription: '',
            planType: ''
        },
        teams: [],
        employees: [],
        perks: [],
        perkPrograms: [],
        currentPerkProgram: {},
        expenseCategories: [],
        expensePrograms: [],
        totalTransaction: []
    };

    const [state, dispatch] = useReducer(appReducer, initialState);

    // TODO: setLoading
    const setLoading = (loading = true) => {
        if (loading) dispatch({ type: 'SET_LOADING' });
        if (!loading) dispatch({ type: 'SET_LOADING_OFF' });
    };

    const transactionsList = async () => {
        setLoading();
        const response = await API.get('/transaction/get-total-transactions').catch(error => {
            console.info(error.isAxiosError && error.message);
        })
        console.log(response);
        if (response && response.data) {
            console.log("Dataa")
            // const totalTransactions = response.data.map(transaction=>{
            //     return {
            //         stripeAuthorizationId: transaction.stripeAuthorizationId,
            //         created: transaction.created,
            //         organizationId: transaction.organizationId,
            //         userId: transaction.userId,
            //         amount: transaction.amount,
            //         cardId: transaction.cardId,
            //         connectedAccountId: transaction.connectedAccountId,
            //         balanceTransaction: transaction.balanceTransaction,
            //         merchantData: transaction.merchantData,
            //         status: transaction.status,
            //         transactionType: transaction.transactionType
            //     }
            // })
            const totalTransactions = response.data
            console.log("Total Transactions", totalTransactions)
            return dispatch({ type: 'SET_TRANSACTIONSLIST', payload: totalTransactions });
        }
        return dispatch({ type: 'TRANSACTIONSLIST', payload: [] });

    }

    const setEmployees = async () => {
        setLoading();
        const response = await API.post(`/fetch-employees`, {}).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (response && response.data && response.data.data) {
            const employees = response.data.data.map(employeeData => {
                return {
                    id: employeeData._id,
                    teamName: employeeData.teamName || '',
                    teamId: employeeData.teamId,
                    name: `${employeeData.firstName} ${employeeData.lastName}`,
                    email: employeeData.email,
                    status: employeeData.status,
                    editing: { new: false },
                    selected: false,
                    // expenseStatus: 'none',
                    expenseStatus: employeeData.expenseStatus !== undefined ? employeeData.expenseStatus : 'none',
                    cardHolderId: employeeData.stripe.cardHolderId,
                    role: employeeData.role,
                    // role: "employee-ft",
                    shippingAddress: employeeData.shippingAddress,
                    stripe: employeeData.stripe,
                    address: employeeData.address,
                    city: employeeData.city,
                    state: employeeData.state,
                    postalCode: employeeData.postalCode,
                    firstName: employeeData.firstName,
                    lastName: employeeData.lastName,
                    lastLoginAt: employeeData.lastLoginAt || null,
                    createdAt: employeeData.createdAt,
                };
            });
            console.log("Employees from AppState: ");
            console.info({ employees });

            return dispatch({ type: 'SET_EMPLOYEES', payload: employees });
        }
        return dispatch({ type: 'SET_EMPLOYEES', payload: [] });
    };

    const loadTeams = async () => {
        setLoading();
        const response = await API.post(`/fetch-teams`, {}).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        if (!(response && response.data && response.data.data)) return setTeams([]);

        const teams = response.data.data.map(team => {
            // console.info({team});
            return {
                id: team._id,
                size: team.size,
                fundingStatus: team.fundingStatus,
                name: team.name,
                budget: team.budget,
                expenseLimit: team.expenseLimit ? team.expenseLimit : 0,
                location: team.location,
                teamName: team.name, // TODO: name & teamName both not required, remove one by changing all its usage first
                selected: false,
                editing: false,
                perksProgramId: team.perksProgramId || '',
                createdAt: team.createdAt,
                expenseProgramId: team.expenseProgramId || '',
            };
        });
        console.info({ teams });
        return setTeams(teams);
    };

    const setTeams = async (teams = []) => {
        setLoading();
        console.info({ teams });
        return dispatch({ type: 'SET_TEAMS', payload: teams });
    };

    const setAuthorizedUser = async (user) => {
        // await localStorage.setItem('user', user)
        dispatch({ type: 'SET_USER', payload: user });
    };

    const setUser = async (accessToken) => {
        setLoading();
        const response = await API.post(`/dashboard-authenticate`, { accessToken }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        if (response && response.data && response.data.data) {
            const user = response.data.data;
            console.info({ user });
            // await localStorage.setItem('user', user)
            await localStorage.setItem('email', user.email)
            return dispatch({ type: 'SET_USER', payload: user });
        }
        return dispatch({ type: 'SET_USER', payload: {} });
    };

    const setVerifiedUser = async (user) => {
        setLoading();
        // await localStorage.setItem('user', user)
        return dispatch({ type: 'SET_USER', payload: user });
    };

    const setUnverifiedUser = async (user) => {
        setLoading();
        console.log("Unv Userr", user)
        // await localStorage.setItem('user', user)
        return dispatch({ type: 'SET_USER', payload: user });
    };

    const logOut = () => {
        setLoading();
        return dispatch({ type: 'USER_LOG_OUT', payload: {} });
    };

    const setOrganization = async (accessToken) => {
        setLoading();
        API = axios.create({ baseURL, headers: { 'Authorization': `Bearer ${accessToken}` }, }); // get updated token
        const response = await API.post(`/fetch-organization`).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        if (response && response.data && response.data.data) {
            const { data: organization, status } = response.data;
            console.info({ organization });
            console.info(status);
            // await localStorage.setItem('organization', organization)
            // organization/pending-payment-source-verification
            return dispatch({ type: 'SET_ORGANIZATION', payload: { ...organization } });
        }
        return dispatch({ type: 'SET_ORGANIZATION', payload: {} });
    };

    const setVerifiedOrganization = async (organization) => {
        setLoading();
        // await localStorage.setItem('organization', organization)
        return dispatch({ type: 'SET_ORGANIZATION', payload: { ...organization } });
    };

    const setOrganizationPartialInfo = async (organization) => {
        setLoading();
        return dispatch({ type: 'SET_ORGANIZATION', payload: {...organization} });
    };

    const setUnverifiedOrganization = async (organization) => {
        setLoading();
        console.log("Unverifieddd", organization)
        // await localStorage.setItem('organization', organization)
        return dispatch({ type: 'SET_ORGANIZATION', payload: { ...organization, verified: false } });
    };

    const updateOrganization = async (organization) => {
        setLoading();
        const response = await API.post(`/update-organization`, organization).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        if (response && response.data && response.data.data) {
            const updatedOrganization = response.data.data;
            console.info({ updatedOrganization });
            return dispatch({
                type: 'SET_ORGANIZATION',
                payload: updatedOrganization,
            });
        }
        return dispatch({ type: 'SET_ORGANIZATION', payload: {} });
    };

    const addPerksProgram = async (perkProgram) => {
        setLoading();
        console.info({ perkProgram });
        console.table({
            ...perkProgram,
            startDate: moment(perkProgram.startDate).format('YYYY-MM-DD'),
            endDate: moment(perkProgram.endDate).format('YYYY-MM-DD'),
        });
        const response = await API.post(`/perks-program/create`, {
            ...perkProgram,
            // startDate: moment(perkProgram.startDate).format('YYYY-MM-DD'),
            // endDate: moment(perkProgram.endDate).format('YYYY-MM-DD'),
            startDate: perkProgram.startDate,
            endDate: perkProgram.endDate,
        }).catch(error => {
            console.error(error.isAxiosError && error.message);
            return 0;
        });
        if (response && response.data && response.data.data) {
            const result = response.data.data;
            console.info({ result });
            const newPerksProgram = {
                id: result._id,
                name: result.name,
                startDate: new Date(result.startDate),
                endDate: perkProgram.neverExpire ? null : new Date(result.endDate),
                frequency: result.frequency,
                active: true, // TODO: should be based on date comparison
            };

            await API.post('/recentActions', { task: "Perk Program " + newPerksProgram.name + " created" })

            return dispatch({ type: 'ADD_PERKS_PROGRAM', payload: newPerksProgram });
        }else{
            setLoading(false)
            return false;
        }
    };

    const addTeam = async (team) => {
        setLoading();
        const response = await API.post(`/create-team`, team).catch(error => {
            console.error(error.isAxiosError && error.message);
            return 0;
        });
        if (response && response.data && response.data.data) {
            const result = response.data.data;
            console.info({ result });
            const newTeam = {
                id: result._id,
                name: result.name,
                budget: result.budget,
                expenseLimit: result.expenseLimit,
                location: result.location,
                size: result.size,
                fundingStatus: result.fundingStatus,
                organizationId: result.organizationId,
                createdAt: new Date()
            };

            await API.post('/recentActions', { task: "New Team " + newTeam.name + " created" })

            return dispatch({ type: 'ADD_TEAM', payload: newTeam });
        }
    };

    const updateTeam = async (team) => {
        setLoading();
        const response = await API.post(`/update-team`, {
            id: team.id,
            name: team.name,
            budget: team.budget,
            expenseLimit: team.expenseLimit
        }).catch(error => {
            console.error(error.isAxiosError && error.message);
            return 0;
        });
        if (response && response.data && response.data.data) {
            const result = response.data.data;
            console.info({ result });
            return dispatch({ type: 'UPDATE_TEAM', payload: team });
        }
    };

    const deleteTeam = (teamId) => {
        return dispatch({ type: 'DELETE_TEAM', payload: teamId });
    };

    const deletePerksProgram = (programId) => {
        return dispatch({ type: 'DELETE_PERKS_PROGRAM', payload: programId });
    };

    const addEmployee = async (employee) => {
        setLoading();
        const response = await API.post(`/register-employee`, employee).catch(error => {
            setLoading(false);
            console.error(error.isAxiosError && error.message);
            return 0;
        });
        if (response && response.status === 200 && response.data && response.data.data) {
            const result = response.data.data;
            console.info({ result });

            const newEmployee = {
                id: result._id,
                teamName: 'Unassigned',
                name: `${employee.firstName} ${employee.lastName}`,
                status: result.status,
                editing: { new: false },
                email: result.email,
                contactNumber: employee.contactNumber,
                teamId: "",
            };

            await API.post('/recentActions', { task: "Employee " + newEmployee.name + " added" })
            await setEmployees();
            setLoading(false);
            return result._id;
            // return dispatch({type: 'ADD_EMPLOYEE', payload: newEmployee});
        }else return false
    };

    const deleteEmployee = async (id) => {
        setLoading();
        const response = await axios.post(baseURL + '/employee/delete', { employeeId: id }, {
            headers: {
                Authorization: "Bearer " + accessToken
            }
        })
        if (response.status === 200) {
            const updatedEmployees = state.employees.filter(emp => { return emp.id !== id })
            return dispatch({ type: 'SET_EMPLOYEES', payload: updatedEmployees });
        }
        setLoading(false);
    }

    const addEmployeesToTeam = async (employeeIds, teamId) => {
        setLoading();
        const employeesBulkUploaded = await API.post(`/team/add-employees`, { employeeIds, teamId }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        console.info({ employeesBulkUploaded });
        if(employeesBulkUploaded.status === 200){
            await setEmployees();
            setLoading(false)
            console.log("Check thisssssss", employeesBulkUploaded.data.data)
            return employeesBulkUploaded.data.data;
        }
        setLoading(false)
        return false;
    }

    const bulkUploadEmployees = async (file) => {
        setLoading();

        const formData = new FormData();
        formData.append("file", file);

        const response = await API.post(`/bulk-upload-employees-csv`, formData).catch(error => {
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                console.info(error.response.data.status);
                var code = error.response.data.status.code;
                var message = error.response.data.status.message;
                return { code: code, message: message, data: null };
            } else {
                return { code: 'api/failed', message: `There was an error. Please try again later.`, data: null }
            }
        });

        console.info({ employeesBulkUploaded: response });

        if (response && response.data && response.data.status) {
            const { code } = response.data.status;
            if (code && code === `employees/registered`) {
                return { code: response.data.status.code, message: response.data.status.message, data: response.data.data };
            } else {
                return null;
            }
        }
    }

    const loadPerkPrograms = async () => {
        setLoading();
        const orgPerksPrograms = await API.post(`/perks-program/get-all`).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (orgPerksPrograms && orgPerksPrograms.data && orgPerksPrograms.data.data) {
            const perksPrograms = orgPerksPrograms.data.data;
            const currentDate = new Date();
            const programs = perksPrograms.map(program => {
                const { id, name, startDate, endDate, frequency, perks } = program;
                const startDateObj = new Date(startDate);
                const endDateObj = endDate ? new Date(endDate) : null;
                /*console.info(`${name} is active: ${endDateObj.getTime()} <= ${currentDate.getTime()} : `, endDateObj.getTime() <= currentDate.getTime());
                console.info(`${name} is active: ${new Date(endDateObj)} <= ${new Date(currentDate)} : `, new Date(endDateObj) <= new Date(currentDate));*/
                // const active = endDate ? endDateObj.getTime() >= currentDate.getTime() && startDateObj.getTime() <= currentDate.getTime() : true;
                const active = endDate ? endDateObj.getTime() >= currentDate.getTime() : true;
                return { id, name, startDate: startDateObj, endDate: endDateObj, frequency, active, perks };
            });
            return dispatch({ type: 'SET_PERK_PROGRAMS', payload: programs, });
        } else {
            return dispatch({ type: 'SET_PERK_PROGRAMS', payload: [] });
        }
    };

    const updatePerksProgram = async (perksProgram) => {
        setLoading();
        const response = await API.post(`/update-perk-program`, {
            programId: perksProgram.id,
            name: perksProgram.name,
            // startDate: moment(perksProgram.startDate).format('YYYY-MM-DD'),
            // endDate: moment(perksProgram.endDate).format('YYYY-MM-DD'),
            startDate: perksProgram.startDate,
            endDate: perksProgram.endDate,
            neverExpire: !perksProgram.endDateEnabled,
        }).catch(error => {
            console.error(error.isAxiosError && error.message);
            return null;
        });
        if (response && response.data && response.data.data) {
            const result = response.data.data;
            console.info({ result });
            const { code, message } = response.data.status;
            console.info({ code, message });
            if (code === `perkProgram/updated`) {
                dispatch({ type: 'UPDATE_PERKS_PROGRAM', payload: { ...perksProgram, endDate: perksProgram.endDateEnabled ? perksProgram.endDate : null } });
                return true;
            } else {
                return null;
            }
        }
    };

    const loadGlobalPerks = async () => {
        setLoading();
        const globalPerks = await API.get(`/perks`).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (globalPerks && globalPerks.data && globalPerks.data.data) {
            return dispatch({
                type: 'SET_PERKS',
                payload: globalPerks.data.data,
            });
        }
        return dispatch({ type: 'SET_PERKS', payload: [] });
    };

    const setGlobalPerks = async (perks) => {
        return dispatch({ type: 'SET_PERKS', payload: perks });
    };

    const fetchSinglePerksProgram = async (programId) => {
        setLoading();
        const program = await API.post(`/perks-program/get-one`, { programId }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (program && program.data && program.data.data) {

            console.info({ currentPerkProgram: program.data.data });

            return program.data.data;

            /*return dispatch({
                type: 'SET_CURRENT_PERK_PROGRAM',
                payload: program.data.data,
            });*/
        } else {
            return null;
        }
        // return dispatch({type: 'SET_CURRENT_PERK_PROGRAM', payload: {}});
    };

    const addPerkToPerkProgram = async (programId, perk) => {
        setLoading();

        const parameters = {
            programId, perk: {
                id: perk.id,
                priceLimit: perk.price,
            }
        };

        const addPerkAction = await API.post(`/perks-program/add-perks`, parameters).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        if (addPerkAction && addPerkAction.data && addPerkAction.data.status && addPerkAction.data.status.code && addPerkAction.data.status.code === 'perksProgram/perks-added') {
            setLoading(false);
            return true;
        }

        setLoading(false);
        return null;
    };

    const addAllPerksToProgram = async (programId, perksToSend) => {
        setLoading();
        const addPerkAction = await API.post(`/perks-program/add-all-perks`, {programId, perksToSend}).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        console.log(addPerkAction)

        if (addPerkAction && addPerkAction.data && addPerkAction.data.status && addPerkAction.data.status.code && addPerkAction.data.status.code === 'perksProgram/perks-added') {
            setLoading(false);
            return true;
        }

        setLoading(false);
        return null;
    }

    const removePerkFromPerkProgram = async (programId, perkId) => {
        setLoading();
        const globalPerks = await API.post(`/perks-program/remove-perk`, { programId, perkId }).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        if (globalPerks && globalPerks.data && globalPerks.data.status && globalPerks.data.status.code && globalPerks.data.status.code === 'perksProgram/perk-removed') {
            setLoading(false);
            return true;
        }

        setLoading(false);
        return null;
    };

    const assignTeamsToPerkProgram = async (programId, teamIds) => {
        setLoading();
        const globalPerks = await API.post(`/perks-program/assign-to-teams`, { programId, teamIds }).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        if (globalPerks && globalPerks.data && globalPerks.data.status && globalPerks.data.status.code && (globalPerks.data.status.code === 'perksProgram/teams-assigned' || globalPerks.data.status.code === 'perksProgram/teams-removed')) {
            setLoading(false);
            await loadTeams();
            return true;
        }

        setLoading(false);
        return null;
    };

    const loadExpensePrograms = async () => {
        setLoading();
        const orgExpensePrograms = await API.get(`/expense-program/get-org-programs`).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (orgExpensePrograms && orgExpensePrograms.data && orgExpensePrograms.data.data) {
            const expensePrograms = orgExpensePrograms.data.data;
            const currentDate = new Date();
            const programs = expensePrograms.map(program => {
                const { id, name, organizationId, startDate, endDate, frequency, expenseCategories } = program;
                const startDateObj = new Date(startDate);
                const endDateObj = endDate ? new Date(endDate) : null;
                const active = endDate ? endDateObj.getTime() >= currentDate.getTime() && startDateObj.getTime() <= currentDate.getTime() : true;
                return { id, name, startDate: startDateObj, endDate: endDateObj, frequency, expenseCategories, active, selected: false };
            });
            return dispatch({ type: 'SET_EXPENSE_PROGRAMS', payload: programs, });
        } else {
            return dispatch({ type: 'SET_EXPENSE_PROGRAMS', payload: [] });
        }
    };

    const loadExpenseCategories = async () => {
        setLoading();
        const allExpenseCategories = await API.get(`/expense-category/get-all`).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (allExpenseCategories && allExpenseCategories.data && allExpenseCategories.data.data) {
            // console.log("==========")
            // console.log(allExpenseCategories.data.data)
            // console.log("==========")
            const expenseCategories = allExpenseCategories.data.data;
            const categories = expenseCategories.map(category => {
                const { id, name, icon, stripeCategories } = category;
                return { id, name, icon, stripeCategories, selected: false };
            });
            console.info({ categories })
            return dispatch({ type: 'SET_EXPENSE_CATEGORIES', payload: categories, });
        } else {
            console.log("Something wrong here")
            return dispatch({ type: 'SET_EXPENSE_CATEGORIES', payload: [] });
        }
    };

    const getOneExpenseProgram = async (progId) => {
        setLoading();
        const oneExpenseProgram = await API.post(`/expense-program/get-one-program`, { programId: progId }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (oneExpenseProgram && oneExpenseProgram.data && oneExpenseProgram.data.data) {
            const expenseProgram = oneExpenseProgram.data.data;
            const currentDate = new Date();
            const { id, name, organizationId, startDate, endDate, frequency, expenseCategories } = expenseProgram;
            const startDateObj = new Date(startDate);
            const endDateObj = endDate ? new Date(endDate) : null;
            setLoading(false);
            const active = endDate ? endDateObj.getTime() >= currentDate.getTime() && startDateObj.getTime() <= currentDate.getTime() : true;
            return { id, name, startDate: startDateObj, endDate: endDateObj, frequency, expenseCategories, active };
        } else {
            setLoading(false);
            return null;
        }
    };

    const createExpenseProgram = async (program) => {
        setLoading();
        const expenseProgramCreated = await API.post(`/expense-program/create`, { program }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });
        if (expenseProgramCreated && (expenseProgramCreated.status === 200)) {
            if (expenseProgramCreated && expenseProgramCreated.data && expenseProgramCreated.data.data) {
                const expenseProgram = expenseProgramCreated.data.data;
                const currentDate = new Date();
                const { id, name, organizationId, startDate, endDate, frequency, expenseCategories } = expenseProgram;
                const startDateObj = new Date(startDate);
                const endDateObj = endDate ? new Date(endDate) : null;
                const active = endDate ? endDateObj.getTime() >= currentDate.getTime() && startDateObj.getTime() <= currentDate.getTime() : true;
                const cat = (expenseCategories && expenseCategories.length > 0) ? expenseCategories : [];
                await API.post('/recentActions', { task: "Expense Program" + name + " Created" })
                setLoading(false);
                dispatch({ type: 'ADD_EXPENSE_PROGRAM', payload: { id, name, startDate: startDateObj, endDate: endDateObj, frequency, expenseCategories: cat, active, selected: false }, });
                return true;
            } else {
                setLoading(false);
                return false;
            }
        } else {
            setLoading(false);
            return false
        }
    };

    const deleteExpenseProgram = async (progId) => {
        setLoading();
        const deletedExpenseProgram = await API.post(`/expense-program/delete`, { programId: progId }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (deletedExpenseProgram && (deletedExpenseProgram.status === 200)) {
            setLoading(false);
            dispatch({ type: 'DELETE_EXPENSE_PROGRAM', payload: progId });
            return true;
        } else {
            setLoading(false);
            return false;
        }
    };

    const updateExpenseProgram = async (expenseProgram) => {
        setLoading();
        const response = await API.post(`/expense-program/update`, {
            programId: expenseProgram.id,
            name: expenseProgram.name,
            startDate: expenseProgram.startDate,
            endDate: expenseProgram.endDate,
            neverExpire: expenseProgram.endDateEnabled ? expenseProgram.endDateEnabled : false,
        }).catch(error => {
            console.error(error.isAxiosError && error.message);
            return null;
        });
        if (response && response.data && response.data.data) {
            const result = response.data.data;
            console.info({ result });
            const { code, message } = response.data.status;
            console.info({ code, message });
            const currentDate = new Date();
            const { id, name, organizationId, startDate, endDate, frequency, expenseCategories } = result;
            const startDateObj = new Date(startDate);
            const endDateObj = endDate ? new Date(endDate) : null;
            const active = endDate ? endDateObj.getTime() >= currentDate.getTime() && startDateObj.getTime() <= currentDate.getTime() : true;
            const cat = (expenseCategories && expenseCategories.length > 0) ? expenseCategories : [];
            if (code === `expenseProgram/updated`) {
                dispatch({ type: 'UPDATE_EXPENSE_PROGRAM', payload: { id, name, startDate: startDateObj, endDate: endDateObj, frequency, expenseCategories: cat, active, selected: false } });
                return true;
            } else {
                return null;
            }
        }
    };

    const addToExpenseProgram = async ({ programId, expenseCategoryId, spendingControl }) => {
        console.log("===============")
        console.log({ programId, expenseCategoryId, spendingControl })
        setLoading();
        const globalPerks = await API.post(`/expense-program/add-to-program`, { programId, expenseCategoryId, spendingControl }).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        if (globalPerks && globalPerks.data && globalPerks.data.status && globalPerks.data.status.code && globalPerks.data.status.code === 'expenseProgram/categoryAdded') {
            setLoading(false);
            await loadExpensePrograms();
            return true;
        }

        setLoading(false);
        return null;
    };

    const removeExpenseFromExpenseProgram = async ({ programId, expenseCategoryId }) => {
        setLoading();
        const globalPerks = await API.post(`/expense-program/remove-single-expense`, { programId, expenseCategoryId }).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        if (globalPerks && globalPerks.data && globalPerks.data.status && globalPerks.data.status.code && globalPerks.data.status.code === 'expenseProgram/categoryRemoved') {
            setLoading(false);
            await loadExpensePrograms();
            return true;
        }

        setLoading(false);
        return null;
    };

    const assignTeamsToExpenseProgram = async (programId, teamIds) => {
        setLoading();
        const globalExpenses = await API.post(`/expense-program/assign-teams`, { programId, teamIds }).catch(error => {
            setLoading(false);
            console.info(error.isAxiosError && error.message);
        });

        if (globalExpenses && globalExpenses.data && globalExpenses.data.status && globalExpenses.data.status.code && globalExpenses.data.status.code === 'expenseProgram/teams-assigned') {
            setLoading(false);
            await loadTeams();
            return true;
        }

        setLoading(false);
        return null;
    };

    const getExpenseProgramCategories = async (categoryList) => {
        setLoading();
        const allExpenseCategories = await API.get(`/expense-program/get-expense-categories`, { expenseCategories: categoryList }).catch(error => {
            console.info(error.isAxiosError && error.message);
        });

        if (allExpenseCategories && allExpenseCategories.data && allExpenseCategories.data.data) {
            const expenseCategories = allExpenseCategories.data.data;
            const categories = expenseCategories.map(category => {
                const { id, name, icon, stripeCategories } = category;
                return { id, name, icon, stripeCategories };
            });
            return categories;
        } else {
            return false;
        }
    };

    return (<AppContext.Provider value={{
        loading: state.loading,
        user: state.user,
        organization: state.organization,
        teams: state.teams,
        employees: state.employees,
        perks: state.perks,
        perkPrograms: state.perkPrograms,
        expenseCategories: state.expenseCategories,
        expensePrograms: state.expensePrograms,
        transactionsList,
        totalTransaction: state.totalTransaction,
        loadExpensePrograms,
        loadExpenseCategories,
        getOneExpenseProgram,
        createExpenseProgram,
        deleteExpenseProgram,
        updateExpenseProgram,
        addToExpenseProgram,
        removeExpenseFromExpenseProgram,
        assignTeamsToExpenseProgram,
        getExpenseProgramCategories,
        setLoading,
        loadGlobalPerks,
        setGlobalPerks,
        loadPerkPrograms,
        fetchSinglePerksProgram,
        loadTeams,
        setEmployees,
        addEmployeesToTeam,
        addEmployee,
        addTeam,
        updateTeam,
        deleteTeam,
        deletePerksProgram,
        updatePerksProgram,
        addPerksProgram,
        addPerkToPerkProgram,
        removePerkFromPerkProgram,
        assignTeamsToPerkProgram,
        setUser,
        setVerifiedUser,
        setUnverifiedUser,
        setOrganization,
        setOrganizationPartialInfo,
        setUnverifiedOrganization,
        setVerifiedOrganization,
        updateOrganization,
        bulkUploadEmployees,
        setAuthorizedUser,
        logOut,
        deleteEmployee,
        addAllPerksToProgram
    }}>{props.children}</AppContext.Provider>);
};
